exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdi[data-v-1e69f4d8] {\n  color: #929292;\n  width: 20px;\n  margin-right: 5px;\n}", ""]);

// exports
